module.exports = __webpack_public_path__ + "static/media/healthy-life-herb-herbal-svgrepo-com.24b31853.svg";